// Loader.jsx
import React from 'react';
import './Skeleton.css';

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="spinner" />
    </div>
  );
};

export default Loader;